import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchOnlineReviewByPropertiesData } from "../actions/fetchOnlineReviewData"
import { parseFilters } from "../../Filters/utils/fetchData"


const useFetchOnlineReviewByPropertiesData = ({ pageType, customFilters, skip = false }) => {

    const [data, setData] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [totalPages, setTotalPages] = useState(0)
    const data_per_page = 10;
    const dispatch = useDispatch()
    const { applied_filter_values } = useSelector(e => e?.filterReducer);


    useEffect(() => {
        // Use customFilters if provided, otherwise parse from applied_filter_values
        const filters = customFilters || parseFilters(applied_filter_values);
        setIsLoading(true)
        if (!skip) {
            dispatch(fetchOnlineReviewByPropertiesData({
                filters: { ...filters, filters: { ...filters.filters, limit: data_per_page, offset: (page - 1) * data_per_page } },
                pageType: pageType,
                onSuccess: (data) => {
                    setData(data)
                    setTotalPages(data?.total_records || 0)
                    setIsLoading(false)
                },
                onError: (data) => {
                    setData(data)
                    setIsLoading(false)
                }
            }))
        }
    }, [page, customFilters, applied_filter_values, skip, dispatch, pageType])

    function onPageChange(pageNumber) {
        setPage(pageNumber)
    }


    return { data, onPageChange, data_per_page, isLoading, page, totalPages }


}

export default useFetchOnlineReviewByPropertiesData